import React from 'react';
import PageWrapper from '../components/PageWrapper';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  return (
    <PageWrapper>
      {/* Header */}
      <div className="bg-blue-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Wir sind Nordblick</h1>
          <p className="text-xl text-blue-200 max-w-3xl mx-auto font-light">
            Ehrlich, direkt und mit Leidenschaft für Menschen. Das ist unsere Philosophie.
          </p>
        </div>
      </div>

      {/* Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl font-bold text-blue-900 mb-6">Unsere Geschichte</h2>
              <p className="text-slate-600 mb-4 leading-relaxed">
                Gegründet aus der Überzeugung heraus, dass Personaldienstleistung moderner, transparenter und menschlicher sein kann. Nordblick Recruiting steht für eine neue Generation von Personalvermittlern im norddeutschen Raum.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Wir verstehen uns nicht als reinen "Verleiher", sondern als Berater, Wegbegleiter und Partner auf Augenhöhe – für Bewerber und Unternehmen gleichermaßen. Unser hanseatisches Werteverständnis (ein Wort ist ein Wort) prägt unsere tägliche Arbeit.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Team" className="rounded-lg shadow-md w-full h-48 object-cover" />
              <img src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Office" className="rounded-lg shadow-md w-full h-48 object-cover mt-8" />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-blue-900 mb-16">Wofür wir stehen</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: 'FiHeart', title: 'Menschlichkeit', desc: 'Hinter jedem Lebenslauf steckt eine Persönlichkeit. Wir nehmen uns Zeit fürs Zuhören.' },
              { icon: 'FiAnchor', title: 'Verlässlichkeit', desc: 'Norddeutsch bodenständig. Wenn wir etwas zusagen, halten wir es auch. Darauf können Sie sich verlassen.' },
              { icon: 'FiStar', title: 'Qualität', desc: 'Klasse statt Masse. Wir setzen auf passgenaues Matching statt auf wahllose Profilverschickung.' }
            ].map((v, i) => (
              <div key={i} className="bg-white p-8 rounded-xl shadow-sm text-center">
                <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
                  <SafeIcon name={v.icon.replace('Fi', '')} className="h-8 w-8 text-cyan-600" />
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-3">{v.title}</h3>
                <p className="text-slate-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageWrapper>
  );
};

export default About;